export default __webpack_public_path__ + "static/media/shopping-cart-4.69819454.png";